export const titleTemplate = (title: string | null, previousTitle: string | null, originalTitle: string | null) => {
  const currentTitle = document.title;
  if (!title) return originalTitle;

  if (previousTitle && previousTitle !== title) {
    return currentTitle.replace(previousTitle, title);
  }

  if (currentTitle.includes(title)) {
    return currentTitle;
  }

  return `${title} | ${originalTitle}`;
};
